module.exports = __webpack_public_path__ + "static/kran01_3840-c09b56e94403f6f9ba2e54c341fcf428.jpg";